import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  ssDialogService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import threatsScores from './threatsScores';
import controller from './settings-dialog.controller';
import template from './settings-dialog.html';

// Validation
import riskWeightMessagesTpl from './messages/risk.weight.messages.html';
import customerTeamMessagesTpl from './messages/customer.team.messages.html';
import customerTeamDisplayDataMessagesTpl from './messages/customer.team.display.data.messages.html';


class dialogService {
  getOptions($event, { settings, users = [], vendors = [] }) {
    return {
      controller,
      controllerAs: 'settingsDialogVM',
      locals: {
        settings,
        users,
        vendors,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.settingsDialog', [
  alerts,
  bcpDataService,
  constants,
  loaderService,
  ssDialogService,
  threatsScores,
])
  .service('bcpSettingsDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('risk.weight.messages.html', riskWeightMessagesTpl);
    $templateCache.put('customer.team.messages.html', customerTeamMessagesTpl);
    $templateCache.put('customer.team.display.data.messages.html', customerTeamDisplayDataMessagesTpl);
  })
  .name;
